<template>
    <div
            v-if="Boolean(phone)"
            class="service-provider-card-phone"
    >
        {{ phone }}
    </div>
</template>

<script>
    import ServiceProviderAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/ServiceProviderAppResource";

    export default {
        name: "ServiceProviderCardPhone",
        props: {
            serviceProvider: {
                type: ServiceProviderAppResource,
                require: true
            }
        },
        computed: {
            phone() {
                if (!Boolean(this.serviceProvider.hasContact)) {
                    return this.serviceProvider.phone;
                }
                if (Boolean(this.serviceProvider.contactPhone)) {
                    return this.serviceProvider.contactPhone;
                }
                return this.serviceProvider.phone;
            }
        }
    };
</script>